export default __webpack_public_path__ + "static/media/sound.0212175d.svg";